import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { INTEGRATION_PERMISSIONS } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
const IntegrationHooks = () => import('./IntegrationHooks.vue');
const Index = () => import('./Index.vue');
const Webhook = () => import('./Webhooks/Index.vue');
const DashboardApps = () => import('./DashboardApps/Index.vue');
const Slack = () => import('./Slack.vue');
import SettingsContent from '../Wrapper.vue';
const Linear = () => import('./Linear.vue');
const Notion = () => import('./Notion.vue');
const Shopify = () => import('./Shopify.vue');
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
        },
        // Move all integration hooks to use SettingsWrapper for full width
        {
          path: 'openai',
          name: 'settings_integrations_openai',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: () => ({ integrationId: 'openai' }),
        },
        {
          path: 'dialogflow',
          name: 'settings_integrations_dialogflow',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: () => ({ integrationId: 'dialogflow' }),
        },
        {
          path: 'google_translate',
          name: 'settings_integrations_google_translate',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: () => ({ integrationId: 'google_translate' }),
        },
        {
          path: 'dyte',
          name: 'settings_integrations_dyte',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: () => ({ integrationId: 'dyte' }),
        },
        {
          path: 'leadsquared',
          name: 'settings_integrations_leadsquared',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: () => ({ integrationId: 'leadsquared' }),
        },
        // Generic catch-all for other integrations
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'settings_integrations';
        const backUrl =
          params.name === 'settings_integrations_integration'
            ? { name: 'settings_integrations' }
            : '';
        return {
          headerTitle: 'INTEGRATION_SETTINGS.HEADER',
          icon: 'flash-on',
          showBackButton,
          backUrl,
        };
      },
      children: [
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator', INTEGRATION_PERMISSIONS],
          },
          props: route => ({ error: route.query.error }),
        },
      ],
    },
  ],
};
